<template>
  <div>
    <el-row :gutter="20">
      <div v-for="(item,key) in api_profile_data" :key="key" class="text item">
        <el-col :span="5" class="el-col-tbl-key">{{ key }}</el-col>
        <el-col :span="19" class="el-col-tbl-val">
          <pre style="color: white"> <code >{{ item }}</code></pre>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "ApiInfo",
  mounted() {
    this.get_api()
  },
  data() {
    return {
      api_id: this.$route.query.api_id ? this.$route.query.api_id : '-1',
      api_profile_data: null,
    }
  },
  methods: {
    get_api() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/api/api?api_id=" + this.api_id).then((res) => {
        this.api_profile_data = res.data.data
      })
    }
  },
}
</script>

<style scoped>

</style>
